import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons";
import styles from "./SortButton.module.scss";

interface Props {
  onClick: () => void;
  direction?: "ascending" | "descending";
  children: React.ReactNode;
}

export default function SortButton(props: Props) {
  return (
    <button type="button" onClick={props.onClick} className={styles.sortButton}>
      {props.children}
      {props.direction === "ascending" && (
        <CaretUpFill size={10} color="var(--text)" />
      )}
      {props.direction === "descending" && (
        <CaretDownFill size={10} color="var(--text)" />
      )}
    </button>
  );
}
